import RecognitionControls from '../components/pages/RecognitionControls/RecognitionControls.vue'
import RecognitionControlsSportsList from '../components/pages/RecognitionControls/RecognitionControlsSportsList.vue'

export default [
  {
    path: '/recognition-controls/:streamGroupName',
    name: 'recognition-controls',
    component: RecognitionControls,
    props: true,
    meta: { requiredAbilities: ['recognition-controls'] }
  },
  {
    path: '/recognition-controls',
    name: 'recognition-controls-sports-list',
    component: RecognitionControlsSportsList,
    meta: { requiredAbilities: ['recognition-controls'] }
  }
]
